(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('SelectedEmailController', SelectedEmailController);

    SelectedEmailController.$inject = ['$state', '$uibModalInstance', 'User', 'AlertService'];

    function SelectedEmailController($state, $uibModalInstance, User, AlertService) {
        var vm = this;

        vm.email = {};

        User.getLoggedUserEmail({}, onSuccess, onError);

        function onSuccess(result) {
            vm.email.principal = result.email;
        }

        function onError() {}

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            User.checkReportCommandsEmail({principal: vm.email.principal, cc: vm.email.cc}, onSuccessCheck, onErrorCheck);

            function onSuccessCheck() {
                $uibModalInstance.close(vm.email);
            }

            function onErrorCheck() {}
        };

    }
})();
